import { ActionType } from 'redux-promise-middleware'

const { Pending: PENDING, Rejected: REJECTED, Fulfilled: FULFILLED } = ActionType

export { PENDING, REJECTED, FULFILLED }
